module.exports = __webpack_public_path__ + "static/img/right-top-row-3.94e10191.png";